<script>
    export default {

        props: {
            codes: {
                type: Object,
                required: true,
            },
            model: {
                type: Object,
                required: true,
            },
            depth: {
                type: Number,
                default: 0,
            },
            parentPath: {
                type: Array,
                default: () => [],
            },
            folderSelect: {
                type: Boolean,
                required: true,
            }
        },

        inject: ['tree'],

        data:() => ({
            start: 0,
        }),

        computed: {
            isLoading() {
                return this.tree.loading.includes(this.model.id);
            },
            children() {
                return this.getChildren(this.model).slice(this.start, this.start + 50);
            },
            childrenCount() {
                return this.getChildren(this.model).length;
            },
            hasNext() {
                return this.start + 50 < this.childrenCount;
            },
            hasPrevious() {
                return this.start > 0;
            },
            selectable() {
                if (this.isFolder === true && !this.folderSelect) {
                    return false;
                }

                return (this.folderSelect || !this.isFolder);
            },
            open() {
                return this.tree.opened.includes(this.model.id);
            },
            path() {
                return this.parentPath.concat([this.model]);
            },
            isSelected() {
                // if parent or itself is selected
                let that = this;
                let result = this.path.filter(function (parent) {
                    //return that.codes.selected.includes(parent);
                    return that.codes.selected.find(function (item) {
                        return item.id === parent.id;
                    }) !== undefined;
                });

                if (result.length > 0) {
                    return true;
                }

                return this.isSelectedDescending(this.model);
            },
            isHalfSelected() {
                let that = this;

                let result = this.getAllChildren(this.model)
                    .filter(function (parent) {
                        return that.codes.selected.find(function (item) {
                            return item.id === parent.id;
                        }) !== undefined;
                    });

                // TODO possibly broken
                result = result.filter(function (item) {
                    return item !== that.model.id;
                });

                return result.length > 0;
            },
            padding() {
                return 'padding-left:' + (this.depth * 1.5) + 'rem';
            },
            isFolder() {
                return this.model.children;
            }
        },

        methods: {
            next() {
                this.start += 50;
            },
            previous() {
                this.start -= 50;
            },
            getChildren(item) {
                if (!(item.id in this.tree.items)) {
                    return [];
                }

                return this.tree.items[item.id];
            },
            getAllChildren(item) {
                let children = this.getChildren(item);

                let that = this;
                children.forEach(function (child) {
                    children = children.concat(that.getAllChildren(child));
                });

                return children;
            },
            isInList(id) {
                //return _.includes(this.codes.selected, id);
                return this.codes.selected.find(function (item) {
                    return item.id === id;
                }) !== undefined;
            },
            isSelectedDescending: function (model) {
                if (this.isInList(model.id)) {
                    return true;
                }

                // check children!
                // if you are no folder, return
                if (!model.children) {
                    return false;
                }

                // if all of his children are selected, you are selected as well!
                let children = this.getChildren(model);

                if (children.length === 0) {
                    return false;
                }

                let that = this;

                return children.filter(function (parent) {
                    return that.isSelectedDescending(parent);
                }).length === children.length;
            },
            toggleSelect: function () {
                if (this.isSelected) {
                    // inform parent!
                    this.$emit('deselect');

                    // deselect all children!
                    this.deselectWithChildren(this.model);

                    return;
                }

                this.deselectWithChildren(this.model);

                this.codes.selected.push(this.model);
            },
            deselectedChild: function () {
                // if we or our parent is selected...
                if (this.isSelected) {
                    this.$emit('deselect');
                }
                // a child was deselected.

                if (!this.isSelected) {
                    return;
                }

                // we deselect us
                // if we are selected, we deselect us
                let that = this;
                this.codes.selected = this.codes.selected.filter(function (item) {
                    return item.id !== that.model.id;
                });

                // now select all children!

                //this.model.children.forEach(function (item) {
                this.children.forEach(function (item) {
                    that.codes.selected.push(item);
                });
            },
            deselectWithChildren: function (item) {
                if (this.isInList(item.id)) {
                    this.codes.selected = this.codes.selected.filter(function (selected) {
                        return selected.id !== item.id;
                    });
                }

                let that = this;
                this.getChildren(item)
                    .forEach(function (item) {
                        that.deselectWithChildren(item);
                    });
            },
        }
    }
</script>
